import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { UtilityService } from '../../../../../core/utility/services/utility.service';
import { AnalyticsDataModel } from '../../../../analytics/models/analytics.datamodel';
import { CreativePerformanceStatsComponent } from '../../creative-performace-v1/creative-performance-stats/creative-performance-stats.component';

@Component({
	selector: 'app-creative-performance-stats-v7',
	styleUrls: ['./creative-performance-stats-v7.component.css'],
	templateUrl: './creative-performance-stats-v7.component.html'
})
export class CreativePerformanceStatsV7Component extends CreativePerformanceStatsComponent implements OnInit {
	@Input() sectiontitle: any;
	@Input() creativeIndex: number;
	@Input() sectionclass: any;
	@Input() metricsArray: any;
	@Input() creativesNum: any;
	// tslint:disable-next-line: prefer-output-readonly
	@Output() navigationBackEvent = new EventEmitter();
	// tslint:disable-next-line: prefer-output-readonly
	@Output() navigationNextEvent = new EventEmitter();

	public iFrameUrl;
	public updatediFrameUrl;
	public firstSectionClass: any;
	public videoButtonsPath = {
		mute: './assets/creative-assets/unmute-button.svg',
		pause: './assets/creative-assets/pause-button.svg',
		play: './assets/creative-assets/play-button.svg',
		unmute: './assets/creative-assets/mute-button.svg'
	};
	nativeEl: any;
	@ViewChild('iframeRef') iframeRef: ElementRef;
	constructor(protected sanitizer: DomSanitizer, public analyticsDataModel: AnalyticsDataModel) {
		super(analyticsDataModel);
	}

	ngOnInit(): void {
		super.ngOnInit();
		const regEx = /width="([^"]+)"/g;
		if (!UtilityService.isUndefinedOrNull(this.creative.iframeUrl)) {
			this.updatediFrameUrl = this.creative.iframeUrl.replace(
				/width="([^"]+)"/g,
				'width="100%" id="iframeRef" scrolling="no"'
			);
		}
		this.iFrameUrl = this.sanitizer.bypassSecurityTrustHtml(this.updatediFrameUrl);
		this.firstSectionClass = this.sectionclass.split(' ')[0];
	}

	getCreativeSize(thumbnail: string): string {
		if (
			thumbnail.includes('728x90') ||
			thumbnail.includes('468x60') ||
			thumbnail.includes('320x50') ||
			thumbnail.includes('300x50')
		) {
			return '100% 30%';
		} else if (thumbnail.includes('300x600')) {
			return '75% 100%';
		} else if (thumbnail.includes('160x600')) {
			return '40% 100%';
		} else {
			return '100% 100%';
		}
	}
	isTypeString(description: any): boolean {
		return typeof description === 'string';
	}

	navigateLeft(): void {
		this.navigationBackEvent.emit(this.creativeIndex);
	}

	navigateRight(): void {
		this.navigationNextEvent.emit(this.creativeIndex);
	}
}
